
import {
    GET_SYSTEM_SETTINGS,
    GET_SYSTEM_SETTINGS_SUCCESS,
    GET_SYSTEM_SETTINGS_FAIL,
    UPDATE_SYSTEM_SETTINGS,
    UPDATE_SYSTEM_SETTINGS_SUCCESS,
    UPDATE_SYSTEM_SETTINGS_FAIL
} from "./actionTypes"

export const getSystemSettings = () => ({
    type: GET_SYSTEM_SETTINGS,
})

export const getSystemSettingsSuccess = settings => ({
    type: GET_SYSTEM_SETTINGS_SUCCESS,
    payload: settings,
})

export const getSystemSettingsFail = error => ({
    type: GET_SYSTEM_SETTINGS_FAIL,
    payload: error,
})

export const updateSystemSettings = settings => ({
    type: UPDATE_SYSTEM_SETTINGS,
    payload: settings,
})

export const updateSystemSettingsSuccess = message => ({
    type: UPDATE_SYSTEM_SETTINGS_SUCCESS,
    payload: message,
})

export const updateSystemSettingsFail = error => ({
    type: UPDATE_SYSTEM_SETTINGS_FAIL,
    payload: error,
})
